<div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h4>Products</h4>
        <button class="btn btn-primary">+ Add Product</button>
    </div>

    <div class="row">
        <div class="col-md-3 mb-3" *ngFor="let field of fields">
            <input type="text" class="form-control" [placeholder]="field">
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-md-6">
            <label>Images (.jpg, 1MB)</label>
            <div class="d-flex flex-wrap gap-2">
                <div class="upload-box" *ngFor="let img of imageSlots">
                    <img src="assets/img/image-placeholder-45.png" class="img-thumbnail" alt="Image"
                        style="width: 60px;">
                </div>
                <div class="upload-box">
                    <button class="btn btn-sm btn-outline-secondary">+</button>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <label>Videos (.MP4, 10MB)</label>
            <div class="d-flex flex-wrap gap-2">
                <div class="upload-box" *ngFor="let vid of videoSlots">
                    <img src="assets/img/icons8-video-45.png" class="img-thumbnail" alt="Video" style="width: 60px;">
                </div>
                <div class="upload-box">
                    <button class="btn btn-sm btn-outline-secondary">+</button>
                </div>
            </div>
        </div>
    </div>

    <div class="text-center mt-4">
        <button class="btn btn-primary">SUBMIT</button>
    </div>



    <div class="col-md-6 text-end">
        <button class="btn btn-sm btn-outline-info">View All</button>
    </div>
</div>